<template>
  <div>
    <div class="page-header clear-filter" filter-color="orange">
      <parallax
        class="page-header-image"
        style="background-image:url('img/pool_aerial.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h2 class="title">Civil</h2>
          <h3 class="title">Elevate your perspective…</h3>
          <div class="text-center">
            <a href="https://www.facebook.com/NACS716" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-facebook-square"></i>
            </a>
            <a href="https://twitter.com/nacs716" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.instagram.com/nacs716/" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
          <h3 class="title"><a href="tel:716-479-2927">716.479.2927</a></h3>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
            <div class="col-md-10 ml-auto mr-auto">
                <h2 class="summarynacs mb-5 text-center">
                  Call us for all your civil construction needs...
                </h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10 ml-auto mr-auto">
                <div class="row collections">
                    <div class="col-md-6">
                        <h4 class="summarynacs mb-5 text-center">
                            Sample GPS Surface Model
                        </h4>
                        <img src="/img/civil_1.jpg" class="img-raised" />
                    </div>
                    <div class="col-md-6">
                        <h4 class="summarynacs mb-5 text-center">
                            Sample Earth-Work Takeoff
                        </h4>
                        <img src="/img/civil_2.jpg" alt="" class="img-raised" />
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'pricing',
  bodyClass: 'profile-page',
  components: {
  }
};
</script>
<style scoped>
.summarynacs {
  color: #328ACA;
}
</style>
